import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaFacturasBase64_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultarFactura",
    rutaEndPoint: "/EnterpriseServices/Brm/Factura/consultarFactura",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface ConsultaFacturasBase64_Entrada {
    ConsultarFacturaRequest: ConsultarFacturaRequest;
}

export function builtConsultaFacturasBase64Input(l_ConsultarFacturaRequest: ConsultarFacturaRequest) {
    var retorno: ConsultaFacturasBase64_Entrada = {
        ConsultarFacturaRequest: l_ConsultarFacturaRequest
    };
  
    return retorno;
}

export interface ConsultarFacturaRequest {
    NumeroCuenta: string;
}

export function builtConsultarFacturaRequestInput(l_numeroCuenta: string) {
    var retorno: ConsultarFacturaRequest = {
        NumeroCuenta: l_numeroCuenta
    };
  
    return retorno;
}


  //SALIDA

 export interface ConsultaFacturasBase64_Salida {
    EBMHeaderResponse: EBMHeaderResponse;
    ConsultarFactura:  ConsultarFactura;
}

export interface ConsultarFactura {
    ConsultarFactura: ConsultarFacturaElement[];
}

export interface ConsultarFacturaElement {
    uuid:          string;
    CuentaSKY:     string;
    TipoArchivo:   string;
    factura:       string;
    fechacorte:    Date;
    FechaTimbrado: Date;
    Descripcion:   string;
    id_doc_edicom: number;
    serie:         string;
    Pac:           string;
}

export interface EBMHeaderResponse {
    ErrorTecnico: ErrorTecnico;
    ErrorNegocio: ErrorNegocio;
}

export interface ErrorNegocio {
    Estado:           string;
    CodigoError:      string;
    DescripcionError: string;
}

export interface ErrorTecnico {
    code:    string;
    Sistema: string;
}


export type ConsultaFacturasBase64_Respuesta = EncabezadoRespuestaInterna &
ConsultaFacturasBase64_Salida;